/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { cached } from '@glimmer/tracking';
import { type Select } from 'ember-power-select/components/power-select';
import { type MultiSelectListFilter } from 'uplisting-frontend/utils/filters/types';
import BaseMultiSelectFilterComponent from 'uplisting-frontend/components/ui/filters/filter/-multi-select-base';
import SelectedComponent from 'uplisting-frontend/components/ui/filters/filter/multi-select-list/selected';
import BeforeOptionsComponent from 'uplisting-frontend/components/ui/filters/filter/multi-select/before-options';
import { FilterId } from 'uplisting-frontend/utils/filters/abstract';

export interface IExtra {
  counter?: string;
  handleChange(value: null): void;
}

export default class UiFiltersFilterMultiSelectListComponent extends BaseMultiSelectFilterComponent<MultiSelectListFilter> {
  selectedComponent = SelectedComponent;
  beforeOptionsComponent = BeforeOptionsComponent;

  @cached
  get title(): string {
    return this.filter.params.selectedRecords?.join(', ') ?? '';
  }

  @cached
  get shouldTranslateOptions(): boolean {
    return (
      this.filter.id !== FilterId.country && this.filter.id !== FilterId.city
    );
  }

  @cached
  get extra(): IExtra {
    const { filter } = this;

    const base: IExtra = {
      handleChange: this.handleChange.bind(this),
    };

    const value = filter.params.value as string[];

    if (value.length >= 2) {
      base.counter = `+${value.length - 1}`;
    }

    return base;
  }

  @action
  handleChange(data: string | null): void {
    if (data === null) {
      this.filter.reset();
    } else {
      this.filter.updateValue(data);
    }

    this.args.onFilterUpdate();
  }

  @action
  buildSelection(item: string): string {
    return item;
  }

  @action
  handleOpen(_select: Select, event: MouseEvent): false | undefined {
    // ignore open when click is made on the reset filter icon
    if (
      (event.target as HTMLSpanElement)?.classList.contains(
        'ember-power-select-clear-btn',
      )
    ) {
      return false;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ui/filters/filter/MultiSelectList': typeof UiFiltersFilterMultiSelectListComponent;
    'Ui::Filters::Filter::MultiSelectList': typeof UiFiltersFilterMultiSelectListComponent;
  }
}
